import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class RoofStructures extends Component {
  render() {
    return (
      <EntityList apiRoute='api/roofstructures' title='Remorque - Structures de toit' editTitle='Structure de toit' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default RoofStructures;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/roofStructures.js
 **/